import React from "react";
import LayoutsHome from "../Components/Layouts/LayoutsHome";
import "../styles/PrivacyStyle.css"; // Make sure this CSS file exists
import { Helmet } from "react-helmet-async";

function Privacy() {
  return (
    <>
      <Helmet>
        <title>Privacy Policy | Spectacular Seminars</title>

        <meta
          name="description"
          content="Read Spectacular Seminars' Privacy Policy to understand how we collect, use, protect, and manage your personal information when you use our website, register for events, or access our services."
        />

        <meta
          name="keywords"
          content="privacy policy, Spectacular Seminars privacy, personal data protection, user privacy, website privacy policy, martial arts seminar privacy, data security policy"
        />
      </Helmet>
      <LayoutsHome>
        <div className="privacy-container">
          <h1 className="privacy-title">Privacy Policy</h1>
          <p className="privacy-date">Effective Date: 01/05/2025</p>

          <section className="privacy-section">
            <p className="privacy-text">
              Spectacular Seminars ("we", "us", or "our") respects your privacy
              and is committed to protecting your personal information. This
              Privacy Policy explains how we collect, use, disclose, and
              safeguard your data when you visit our website at
              https://spectacularseminars.com ("Site") or interact with our
              services.
            </p>
            <p className="privacy-text">
              By using our Site, you consent to the practices described in this
              Policy.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-heading">1. Information We Collect</h2>
            <h3 className="privacy-subheading">a. Personal Information</h3>
            <ul className="privacy-list">
              <li>Name</li>
              <li>Email address</li>
              <li>Phone number</li>
              <li>Billing address and payment details (if applicable)</li>
              <li>Any other information you voluntarily provide</li>
            </ul>

            <h3 className="privacy-subheading">
              b. Automatically Collected Information
            </h3>
            <ul className="privacy-list">
              <li>IP address</li>
              <li>Browser type</li>
              <li>Operating system</li>
              <li>Pages viewed</li>
              <li>Date/time of visit</li>
              <li>Referral source</li>
            </ul>
            <p className="privacy-text">
              We use cookies and similar tracking technologies for analytics and
              user experience improvements. You can control cookie settings in
              your browser.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-heading">2. How We Use Your Information</h2>
            <ul className="privacy-list">
              <li>Register you for seminars, webinars, and events</li>
              <li>Process payments and send confirmations</li>
              <li>Respond to inquiries and customer service requests</li>
              <li>
                Send newsletters, updates, and promotional materials (if opted
                in)
              </li>
              <li>Improve our website, services, and user experience</li>
              <li>Comply with legal obligations</li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-heading">3. Sharing Your Information</h2>
            <p className="privacy-text">
              We do <strong>NOT</strong> sell your personal information. We may
              share it with:
            </p>
            <ul className="privacy-list">
              <li>Payment processors and event management platforms</li>
              <li>Email marketing platforms (e.g., for newsletters)</li>
              <li>Service providers who support our operations</li>
              <li>
                Authorities, if required by law or in connection with legal
                claims
              </li>
            </ul>
            <p className="privacy-text">
              All third-party services we use are required to protect your data
              in accordance with this Policy and applicable law.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-heading">4. Your Choices</h2>
            <ul className="privacy-list">
              <li>
                Opt out of marketing emails by clicking "unsubscribe" at the
                bottom of any promotional email.
              </li>
              <li>
                Request access to or correction of your personal data by
                contacting us at{" "}
                <a href="mailto:host@spectacularseminars.com">
                  host@spectacularseminars.com
                </a>
              </li>
              <li>
                Request that we delete your data, subject to legal and
                contractual obligations.
              </li>
            </ul>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-heading">5. Data Security</h2>
            <p className="privacy-text">
              We implement reasonable technical and organizational measures to
              protect your information from unauthorized access, disclosure,
              alteration, or destruction. However, no method of transmission
              over the internet is 100% secure.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-heading">6. Third-Party Links</h2>
            <p className="privacy-text">
              Our Site may contain links to other websites. We are not
              responsible for their privacy practices. We encourage you to
              review the privacy policies of any third-party sites you visit.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-heading">7. Children's Privacy</h2>
            <p className="privacy-text">
              Our services are not intended for individuals under the age of 13.
              We do not knowingly collect personal information from children. If
              we learn that we have collected data from a child under 13, we
              will delete it promptly.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-heading">
              8. Changes to This Privacy Policy
            </h2>
            <p className="privacy-text">
              We may update this Privacy Policy from time to time. The latest
              version will always be posted on our Site with the effective date
              at the top. Continued use of the Site after any changes signifies
              your acceptance of the updated Policy.
            </p>
          </section>

          <section className="privacy-section">
            <h2 className="privacy-heading">9. Contact Us</h2>
            <p className="privacy-text">
              If you have any questions or concerns about this Privacy Policy,
              please contact us:
            </p>
            <p className="privacy-text">
              Spectacular Seminars
              <br />
              Email:{" "}
              <a href="mailto:host@spectacularseminars.com">
                host@spectacularseminars.com
              </a>
              <br />
              Phone: 855-454-2448
              <br />
              Website:{" "}
              <a href="https://spectacularseminars.com">
                https://spectacularseminars.com
              </a>
            </p>
          </section>
        </div>
      </LayoutsHome>
    </>
  );
}

export default Privacy;
